module.exports = __webpack_public_path__ + "img/regolestorie04.d7652f24.png";